var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',{staticClass:"item sort"},[_vm._l((5),function(item){return _c('th',{key:item},[_c('v-skeleton-loader',{attrs:{"type":"text"}})],1)}),_c('th')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }